import script from "./ReserveForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveForm.vue?vue&type=script&setup=true&lang=js"

import "./ReserveForm.vue?vue&type=style&index=0&id=14bc5dea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bc5dea"]])

export default __exports__